import React from "react";
import Notes from "./Notes";

export const Home = () => {
  return (
    <>
      <Notes/>
    </>
  );
};

export default Home;
